export default class SvgHelper {
  // returns SVG image dimensions as { height, width } - if values are false - it is impossible to recognize dimensions
  static getSvgSize (svgCode) {
    let svgElements = svgCode.match(/\<svg[\s\S]*?\>/gmi);

    if (!svgElements) {
      return {
        height: false,
        width: false
      };
    }

    let hasViewbox = svgElements[0].indexOf('viewBox=') > -1;
    let hasWidth = svgElements[0].indexOf('width=') > -1;
    let hasHeight = svgElements[0].indexOf('height=') > -1;

    if (hasViewbox) {
      let viewbox = svgElements[0].match(/viewBox="(.*?)"/gmi);

      if (viewbox[0]) {
        viewbox = viewbox[0].replace(/viewBox="/gmi, '').replace('"', '');
        viewbox = viewbox.split(' ');

        if (
          viewbox[2] &&
          viewbox[3] &&
          // eslint-disable-next-line
          !isNaN(parseFloat(viewbox[2])) &&
          // eslint-disable-next-line
          !isNaN(parseFloat(viewbox[3]))
        ) {
          return {
            height: parseFloat(viewbox[3]),
            width: parseFloat(viewbox[2])
          }
        }
      }
    } else if (hasWidth && hasHeight) {
      let width = svgElements[0].match(/width="(.*?)"/gmi);
      let height = svgElements[0].match(/height="(.*?)"/gmi);

      if (width && height && width[0] && height[0]) {
        width = width[0].replace(/width="/gmi, '').replace('"', '');
        height = height[0].replace(/height="/gmi, '').replace('"', '');

        if (
          width &&
          height &&
          // eslint-disable-next-line
          !isNaN(parseFloat(width)) &&
          // eslint-disable-next-line
          !isNaN(parseFloat(height))
        ) {
          return {
            height: parseFloat(width),
            width: parseFloat(height)
          }
        }
      }
    }

    return {
      height: false,
      width: false
    };
  }

  // calculates initial image position according to given area. Returns { x, y, scale }
  static calculateInitialPosition (imageDimensions, areaDimensions) {
    // image is smaller than area
    if (imageDimensions.width <= areaDimensions.width && imageDimensions.height <= areaDimensions.height) {
      // try to use scale 2.5
      if (imageDimensions.width * 2.5 <= areaDimensions.width && imageDimensions.height * 2.5 <= areaDimensions.height) {
        return {
          scale: 2.5,
          x: (areaDimensions.width - (imageDimensions.width * 2.5)) / 2,
          y: (areaDimensions.height - (imageDimensions.height * 2.5)) / 2
        };
      }
      // otherwise - find proper scale value
      let scaleX = areaDimensions.width / imageDimensions.width;
      let scaleY = areaDimensions.height / imageDimensions.height;
      let finalScale = parseFloat(Number(Math.min(scaleX, scaleY)).toFixed(2));

      return {
        scale: finalScale,
        x: (areaDimensions.width - (imageDimensions.width * finalScale)) / 2,
        y: (areaDimensions.height - (imageDimensions.height * finalScale)) / 2
      };
    }

    // Otherwise - image is bigger than area
    let scaleX = 1 / (imageDimensions.width / areaDimensions.width);
    let scaleY = 1 / (imageDimensions.height / areaDimensions.height);
    let finalScale = parseFloat(Number(Math.min(scaleX, scaleY)).toFixed(2));

    return {
      scale: finalScale,
      x: (areaDimensions.width - (imageDimensions.width * finalScale)) / 2,
      y: (areaDimensions.height - (imageDimensions.height * finalScale)) / 2
    };
  }

  // prepares SVG code to use as a layer inside other SVG
  static prepareSvgAsLayer (svgCode) {
    svgCode = SvgHelper._removeComments(svgCode);
    svgCode = SvgHelper._removeHeaders(svgCode);
    svgCode = SvgHelper._removeSvgElementAttributes(svgCode);
    return svgCode;
  }

  // removes unnecessary comments from the SVG file code
  static _removeComments (svgCode) {
    svgCode = svgCode.replace(/\<!--[\s\S]*?--\>/gmi, '');
    return svgCode;
  }

  // removes initial part of the code till first <svg occurence
  static _removeHeaders (svgCode) {
    let headingPart = svgCode.match(/^[\s\S]*?\<svg/gmi);
    svgCode = svgCode.replace(headingPart[0], '<svg');
    return svgCode;
  }

  // removes all attributes from the <svg> element
  static _removeSvgElementAttributes (svgCode) {
    let svgElements = svgCode.match(/\<svg[\s\S]*?\>/gmi);
    let svgSize = SvgHelper.getSvgSize(svgCode);

    if (svgElements[0]) {
      svgCode = svgCode.replace(svgElements[0], `<svg width="${svgSize.width}" height="${svgSize.height}">`);
    }

    return svgCode;
  }

  // parse complex product SVG
  static parseComplexProduct (svgDoc) {
    let layers = [];
    let idBase = +new Date();

    for (let i = svgDoc.children.length - 1; i >= 0; i--) {
      let transformAttr = svgDoc.children[i].getAttribute('transform');
      let x = 0;
      let y = 0;
      let scale = 1;
      
      // Skip if element doesn't have transform attribute
      if (!transformAttr) {
        continue;
      }
      
      let translateAttr = transformAttr.match(/translate\(.*?\)/gmi);
      let scaleAttr = transformAttr.match(/scale\(.*?\)/gmi);

      if (translateAttr && translateAttr.length && scaleAttr) {
        translateAttr = translateAttr[0].replace('translate(', '').replace(')', '');
        scaleAttr = scaleAttr[0].replace('scale(', '').replace(')', '');
        x = parseFloat(translateAttr.split(' ')[0]);
        y = parseFloat(translateAttr.split(' ')[1]);
        scale = parseFloat(scaleAttr.split(' ')[0]);
      }

      layers.push({
        id: idBase - i,
        layerX: x,
        layerY: y,
        layerScale: scale,
        svgCode: svgDoc.children[i].innerHTML,
        ingredientID: parseInt(svgDoc.children[i].getAttribute('data-ingredient-id'), 10),
        ingredientName: svgDoc.children[i].getAttribute('data-layer-name'),
        layerScaleInPercents: scale * 100
      });
    }

    return layers;
  }
}
